import React from 'react';
import {
  Menu,
  MenuItem,
  ListSubheader,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@material-ui/core';
import {
  FaBorderNone,
  FaBorderAll,
  FaStream,
  FaPlus,
  FaTrashAlt,
  FaCheck,
  FaTable,
  FaSignature,
  FaCog,
} from 'react-icons/fa';

const MenuTabla = ({
  classes,
  anchorEl,
  onClose,
  estaEnTabla,
  estiloTablaActual,
  onCambiarEstiloTabla,
  onInsertarFila,
  onEliminarFila,
  onInsertarColumna,
  onEliminarColumna,
  onEliminarTabla,
  onInsertarNuevaTabla,
  onAbrirModalPersonalizar,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={onClose}
      disableRestoreFocus
      PaperProps={{
        style: {
          minWidth: 260,
          maxHeight: 460,
        },
      }}
    >
      {estaEnTabla && [
        <ListSubheader disableSticky key="sub-estilos" className={classes.menuItemCategory}>
          Bordes de la tabla actual
        </ListSubheader>,
        <MenuItem
          key="item-sin-bordes"
          selected={estiloTablaActual === 'sin-bordes'}
          onClick={() => onCambiarEstiloTabla('sin-bordes')}
        >
          <ListItemIcon className={classes.tableMenuItemIcon}>
            <FaBorderNone size={14} />
          </ListItemIcon>
          <ListItemText primary="Sin bordes (Transparente / Firmas)" />
          {estiloTablaActual === 'sin-bordes' && <FaCheck size={12} color="#1a73e8" />}
        </MenuItem>,
        <MenuItem
          key="item-con-bordes"
          selected={estiloTablaActual === 'con-bordes'}
          onClick={() => onCambiarEstiloTabla('con-bordes')}
        >
          <ListItemIcon className={classes.tableMenuItemIcon}>
            <FaBorderAll size={14} />
          </ListItemIcon>
          <ListItemText primary="Cuadrícula completa (Con bordes)" />
          {estiloTablaActual === 'con-bordes' && <FaCheck size={12} color="#1a73e8" />}
        </MenuItem>,
        <MenuItem
          key="item-horizontales"
          selected={estiloTablaActual === 'horizontales'}
          onClick={() => onCambiarEstiloTabla('horizontales')}
        >
          <ListItemIcon className={classes.tableMenuItemIcon}>
            <FaStream size={14} />
          </ListItemIcon>
          <ListItemText primary="Solo líneas horizontales" />
          {estiloTablaActual === 'horizontales' && <FaCheck size={12} color="#1a73e8" />}
        </MenuItem>,
        <Divider key="div-1" />,
        <ListSubheader disableSticky key="sub-filas-cols" className={classes.menuItemCategory}>
          Filas y Columnas
        </ListSubheader>,
        <MenuItem key="item-fila-arriba" onClick={() => onInsertarFila('arriba')}>
          <ListItemIcon className={classes.tableMenuItemIcon}>
            <FaPlus size={12} />
          </ListItemIcon>
          <ListItemText primary="Insertar fila arriba" />
        </MenuItem>,
        <MenuItem key="item-fila-abajo" onClick={() => onInsertarFila('abajo')}>
          <ListItemIcon className={classes.tableMenuItemIcon}>
            <FaPlus size={12} />
          </ListItemIcon>
          <ListItemText primary="Insertar fila abajo" />
        </MenuItem>,
        <MenuItem key="item-col-izq" onClick={() => onInsertarColumna('izquierda')}>
          <ListItemIcon className={classes.tableMenuItemIcon}>
            <FaPlus size={12} />
          </ListItemIcon>
          <ListItemText primary="Insertar columna a la izquierda" />
        </MenuItem>,
        <MenuItem key="item-col-der" onClick={() => onInsertarColumna('derecha')}>
          <ListItemIcon className={classes.tableMenuItemIcon}>
            <FaPlus size={12} />
          </ListItemIcon>
          <ListItemText primary="Insertar columna a la derecha" />
        </MenuItem>,
        <MenuItem key="item-del-fila" onClick={onEliminarFila} style={{ color: '#dc2626' }}>
          <ListItemIcon className={classes.tableMenuItemIcon} style={{ color: '#dc2626' }}>
            <FaTrashAlt size={12} />
          </ListItemIcon>
          <ListItemText primary="Eliminar fila actual" />
        </MenuItem>,
        <MenuItem key="item-del-col" onClick={onEliminarColumna} style={{ color: '#dc2626' }}>
          <ListItemIcon className={classes.tableMenuItemIcon} style={{ color: '#dc2626' }}>
            <FaTrashAlt size={12} />
          </ListItemIcon>
          <ListItemText primary="Eliminar columna actual" />
        </MenuItem>,
        <MenuItem key="item-del-tabla" onClick={onEliminarTabla} style={{ color: '#b91c1c', fontWeight: 600 }}>
          <ListItemIcon className={classes.tableMenuItemIcon} style={{ color: '#b91c1c' }}>
            <FaTrashAlt size={12} />
          </ListItemIcon>
          <ListItemText primary="Eliminar tabla completa" />
        </MenuItem>,
        <Divider key="div-2" />,
      ]}

      <ListSubheader disableSticky className={classes.menuItemCategory}>
        {estaEnTabla ? 'Insertar otra tabla' : 'Insertar Tabla'}
      </ListSubheader>
      <MenuItem
        onClick={() =>
          onInsertarNuevaTabla({
            filas: 3,
            columnas: 2,
            estilo: 'con-bordes',
            conEncabezado: true,
          })
        }
      >
        <ListItemIcon className={classes.tableMenuItemIcon}>
          <FaTable size={14} />
        </ListItemIcon>
        <ListItemText primary="Tabla estándar (3×2 con bordes)" />
      </MenuItem>
      <MenuItem
        onClick={() =>
          onInsertarNuevaTabla({
            filas: 2,
            columnas: 2,
            estilo: 'sin-bordes',
            conEncabezado: false,
          })
        }
      >
        <ListItemIcon className={classes.tableMenuItemIcon}>
          <FaSignature size={14} />
        </ListItemIcon>
        <ListItemText primary="Tabla para firmas (sin bordes)" secondary="2 columnas alineadas" />
      </MenuItem>
      <MenuItem
        onClick={() =>
          onInsertarNuevaTabla({
            filas: 3,
            columnas: 2,
            estilo: 'horizontales',
            conEncabezado: true,
          })
        }
      >
        <ListItemIcon className={classes.tableMenuItemIcon}>
          <FaStream size={14} />
        </ListItemIcon>
        <ListItemText primary="Tabla con líneas horizontales" />
      </MenuItem>
      <Divider />
      <MenuItem onClick={onAbrirModalPersonalizar}>
        <ListItemIcon className={classes.tableMenuItemIcon}>
          <FaCog size={14} />
        </ListItemIcon>
        <ListItemText primary="Personalizar filas y columnas..." />
      </MenuItem>
    </Menu>
  );
};

export default React.memo(MenuTabla);
